



























































































































































































































    import { Vue,Component,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import moment from 'moment'
    import icon from '../../assets/js/expressicon'
    const home = namespace('home')

    @Component({
        components: {

        }
    })
    export default class Dashboard extends Vue{
        get chartData() {
            return{
                columns: ['日期', '派件入库', '派件出库', '寄件入库'],
                rows: this.chartList
            }
        }
        get histogramData(){
            return{
                columns: ['日期','共计', '派件出库', '寄件入库', '增值业务','其他'],
                rows: this.chartList
            }
		}
		get packageData(){
            return{
                columns: ['包裹','成都','杭州','总计'],
                rows: [{'包裹': '包裹总计', '成都': 22476,'杭州': 12874,'总计': 35341 }]
            }
        }
        icon:any = icon
        radio2:number =  6
        daterange:any = [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()]
        echartsNav:string = '1'
        @home.State('loading') loading:any
        @home.State('chartList') chartList:any
        @home.State('pkrange') pkrange:any
		@home.State('exrange') exrange:any
        @home.State('dashboard') dashboard:any
        
        @home.Action('getGeneral') getGeneral:any
        @home.Action('getInventory') getInventory:any
        
        async mounted(){
            await this.getGeneral()
			await this.getInventory()
        }
        daterangechange(val:any){
            const end = new Date();
            const start = new Date();
            const daterange:any = [start, end]
            if (val == 6) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            }
            if (val == 9) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            }
            if (val == 12) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            }
            this.daterange = daterange
        }
        async search(){
			if(this.echartsNav == '1'){
				this.getInventory({
					star: moment(this.daterange[0]).format("YYYY-MM-DD"),
					end: moment(this.daterange[1]).format("YYYY-MM-DD")
				})
			}else if(this.echartsNav == '3'){
				console.log('ZAJ');
				
			}
        }
		echartsHandleClick(tab:any, event:any) {
			this.echartsNav = tab.name
		}
        @Watch('daterange')
        onDaterangeChanged(val: any, oldVal: any) {
            this.search()
        }
    }
